import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Navigation from '../layouts/LandingLayout/Navigation/Navigation';
import Footer from '../layouts/LandingLayout/Footer/Footer';
import { Home } from '../pages/home';
import { LiderazgoMinisterio } from '../pages/liderazgoMinisterio';
import { CambioRegiones } from '../pages/cambioRegiones';
import { TransformacionAula } from '../pages/transformacionAula';
import { VocesFamiliasEstudiantes } from '../pages/vocesFamiliasEstudiantes';
import { VideosTestimoniales } from '../pages/videosTestimoniales';
import { EstrategiasComunicacion2025Page } from '../pages/estrategiasComunicacion2025';

export default function Router() {
  return (
    <Routes>
      <Route path='/' element={<><Navigation /><Home /><Footer /></>} />
      <Route path='/liderazgo-desde-el-ministerio' element={<><Navigation /><LiderazgoMinisterio /><Footer /></>} />
      <Route path='/liderazgo/estrategias-comunicacion-2025' element={<><Navigation /><EstrategiasComunicacion2025Page /><Footer /></>} />
      <Route path='/cambio-en-las-regiones' element={<><Navigation /><CambioRegiones /><Footer /></>} />
      <Route path='/transformacion-desde-el-aula' element={<><Navigation /><TransformacionAula /><Footer /></>} />
      <Route path='/voces-familias-y-estudiantes' element={<><Navigation /><VocesFamiliasEstudiantes /><Footer /></>} />
      <Route path='/transformacion-desde-el-aula/testimonios/:id' element={<><Navigation /><VideosTestimoniales /><Footer /></>} />
      <Route path='/voces-familias-y-estudiantes/testimonios/:id' element={<><Navigation /><VideosTestimoniales /><Footer /></>} />
    </Routes>
  );
}


